module.exports = __webpack_public_path__ + "fonts/NeueHaasGroteskText-55Roman-Web.b276207.woff2";